jQuery(document).ready(function () {
	jQuery('.block-testimonial-slider-repeater .slider').slick({
		dots: false,
		appendArrows: jQuery('.slidernav'),
	});
});
